// import * as React from "react";
// import Box from "@mui/material/Box";
// import { alpha, styled } from "@mui/material/styles";
// import TextField from "@mui/material/TextField";
// import Grid from "@mui/material/Grid";
// import { Paper } from "@mui/material";
// import ToggleButton from "@mui/material/ToggleButton";
// import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
// import Typography from "@mui/material/Typography";
// import { LineChart } from "@mui/x-charts/LineChart";
// import { CapitalizeName } from "../../../utils/capitalizeName";
// import Select, { selectClasses } from "@mui/joy/Select";
// import Option from "@mui/joy/Option";
// import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
// import { ReactComponent as DashboardSVG } from './Org_Dashboard1.svg'; // Import the SVG component
// import OrgDashboardSVG from "./OrgDashboardSVG";
// import SampleOrg from "./SampleOrg";
// import { useSelector,useDispatch } from "react-redux";

// const OrganizationDashboard = () => {
//   const dispatch = useDispatch()
//   const {isAuthenticated,user}=useSelector((state)=>state.auth)
//   const name = user?.name || "";
//   const userName = CapitalizeName(name);

//   const CssTextField = styled(TextField)({
//     "& label": {
//       color: "#FEFEFE",
//     },
//     "& .MuiOutlinedInput-root": {
//       "& fieldset": {
//         borderColor: "#B9B9B9",
//         borderRadius: 10,
//       },
//       "&:hover fieldset": {
//         borderColor: "#B9B9B9",
//       },
//       "&.Mui-focused fieldset": {
//         borderColor: "#B9B9B9",
//       },
//       "& .MuiInputBase-input": {
//         color: "#FEFEFE",
//       },
//     },
//   });

//   const Item = styled(Paper)(({ theme }) => ({
//     backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
//     ...theme.typography.body2,
//     padding: theme.spacing(1),
//     textAlign: "center",
//     color: theme.palette.text.secondary,
//   }));

//   const [alignment, setAlignment] = React.useState("Admin Portal");

//   const handleChange = (event, newAlignment) => {
//     if (newAlignment !== null) {
//       setAlignment(newAlignment);
//     }
//   };

//   const adminPortalStyle = {
//     backgroundColor: alignment === "Admin Portal" ? "black" : "#959595",
//     color: alignment === "Admin Portal" ? "white" : "black",
//   };

//   const organizationPortalStyle = {
//     backgroundColor: alignment === "Organisation Portal" ? "black" : "#959595",
//     color: alignment === "Organisation Portal" ? "white" : "black",
//   };

//   return (
//     <div
//       style={{
//         height: "calc(100% - 6%)",
//         overflow: "scroll",
//         overflowX: "hidden",
//         scrollbarWidth: "thin",
//         msOverflowStyle: "none",
//         scrollbarColor: "transparent transparent",
//       }}
//     >
//       <Box sx={{ flexGrow: 1 }}>
      
//         {/* Embed the SVG */}
//         <Box sx={{  marginTop: "8px", textAlign: "center",px:2 }}>
//           {/* <DashboardSVG /> */}
//           {/* <OrgDashboardSVG/> */}
//           <SampleOrg/>
//         </Box>
//       </Box>
//     </div>
//   );
// };

// export default OrganizationDashboard;



import * as React from "react";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Paper } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import { LineChart } from "@mui/x-charts/LineChart";
import { CapitalizeName } from "../../../utils/capitalizeName";
import Select, { selectClasses } from "@mui/joy/Select";
import Option from "@mui/joy/Option";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { ReactComponent as DashboardSVG } from './Org_Dashboard1.svg';
import OrgDashboardSVG from "./OrgDashboardSVG";
import SampleOrg from "./SampleOrg";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgress, Avatar } from "@mui/material";
import createInstance from "../../../api/axiosinstance";


const OrganizationDashboard = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const name = user?.name || "";
  const userName = CapitalizeName(name);
  
  // State for organization data
  const [organizationData, setOrganizationData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const aiDishaApi = createInstance("DISHA");

  // Fetch organization data
  React.useEffect(() => {
    const fetchOrganizationData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('Fetching organization data for user:', user);
        
        // Get organization ID from user data
        const orgId = user?.organizationId;
        if (!orgId) {
          setError('No organization ID found in user data');
          return;
        }
        
        // Try to get organization data from your actual API endpoint
        // Adjust this URL to match your backend route
        const response = await aiDishaApi.get(`/get_organization_by_id?org_id=${orgId}`, {
          // headers: {
          //   'Authorization': `Bearer ${user?.token}`,
          //   'Content-Type': 'application/json',
          // },
        });
        
        console.log('API Response status:', response.status);
        console.log('API Response headers:', response.headers);
        
        if (response.ok) {
          const data = await response.json();
          console.log('Organization data received from API:', data);
          setOrganizationData(data);
        } else {
          // If API fails, try to get data from user object as fallback
          console.warn('API call failed, checking user data...');
          
          // It seems like you already have org data somewhere based on your console logs
          // You might need to get it from a different source or Redux store
          const fallbackData = {
            organization_id: user?.organizationId,
            organization_name: user?.organizationName, // Add these to your user object
            organization_logo_url: user?.organizationLogoUrl, // Add these to your user object
            organization_domain: user?.organizationDomain, // Add these to your user object
          };
          
          if (fallbackData.organization_id) {
            console.log('Using fallback data:', fallbackData);
            setOrganizationData(fallbackData);
          } else {
            const errorText = await response.text();
            console.error('API error response:', errorText);
            setError(`Failed to fetch organization data: ${response.status}`);
          }
        }
      } catch (error) {
        console.error('Network error fetching organization data:', error);
        setError(`Network error: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    if (isAuthenticated && user) {
      fetchOrganizationData();
    } else {
      setLoading(false);
    }
  }, [isAuthenticated, user]);

  // Function to fix malformed S3 URLs
  const fixS3Url = (url) => {
    if (!url) return null;
    
    console.log('Original URL:', url);
    
    // Check if URL is in the wrong format and fix it
    if (url.includes('in-maa-1.linodeobjects.com/ai-codedisha/')) {
      // Wrong format: https://in-maa-1.linodeobjects.com/ai-codedisha/organization logo/...
      // Correct format: https://ai-codedisha.s3.in-maa-1.linodeobjects.com/organization logo/...
      const fixedUrl = url.replace(
        'https://in-maa-1.linodeobjects.com/ai-codedisha/',
        'https://ai-codedisha.s3.in-maa-1.linodeobjects.com/'
      );
      console.log('Fixed URL:', fixedUrl);
      return fixedUrl;
    }
    
    return url;
  };
  const getSignedUrl = async (logoUrl) => {
    try {
      const response = await fetch('/api/generate-signed-url', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${user?.token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ imageUrl: logoUrl }),
      });
      
      if (response.ok) {
        const data = await response.json();
        return data.signedUrl;
      } else {
        console.error('Failed to get signed URL:', response.status);
      }
    } catch (error) {
      console.error('Error getting signed URL:', error);
    }
    return logoUrl; // Return original URL as fallback
  };

  const CssTextField = styled(TextField)({
    "& label": {
      color: "#FEFEFE",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#B9B9B9",
        borderRadius: 10,
      },
      "&:hover fieldset": {
        borderColor: "#B9B9B9",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#B9B9B9",
      },
      "& .MuiInputBase-input": {
        color: "#FEFEFE",
      },
    },
  });

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const [alignment, setAlignment] = React.useState("Admin Portal");

  const handleChange = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  // Simplified Logo component for testing
  const OrganizationLogo = ({ logoUrl, organizationName }) => {
    const [imageError, setImageError] = React.useState(false);
    const [fixedUrl, setFixedUrl] = React.useState(null);

    React.useEffect(() => {
      // Reset error state and fix URL when logoUrl changes
      setImageError(false);
      const correctedUrl = fixS3Url(logoUrl);
      setFixedUrl(correctedUrl);
      console.log('chcekibng org logo url', logoUrl);
      console.log('chcekibng org logo fixed url', correctedUrl);
    }, [logoUrl]);

    const handleImageLoad = () => {
      console.log('Image loaded successfully:', fixedUrl);
    };

    const handleImageError = (e) => {
      console.error('Image failed to load:', fixedUrl);
      console.error('Image error details:', e);
      setImageError(true);
    };

    // Show fallback avatar if no URL or error
    if (!logoUrl || !fixedUrl || imageError) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              backgroundColor: '#1976d2',
              fontSize: '2rem',
            }}
          >
            {organizationName?.charAt(0)?.toUpperCase() || 'O'}
          </Avatar>
          {imageError && (
            <Typography variant="caption" sx={{ color: 'red', mt: 1, display: 'block' }}>
              Failed to load logo
            </Typography>
          )}
        </Box>
      );
    }

    // Show the actual image with fixed URL
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '20px 0' }}>
        <img
          src={fixedUrl}
          alt={`${organizationName} Logo`}
          style={{
            width: '120px',
            height: '80px',
            objectFit: 'contain',
            borderRadius: '8px',
            border: '2px solid #e0e0e0',
            backgroundColor: '#f5f5f5',
          }}
          onLoad={handleImageLoad}
          onError={handleImageError}
          crossOrigin="anonymous"
        />
        {/* Debug info - remove in production */}
        <Typography variant="caption" sx={{ color: '#666', mt: 1, fontSize: '10px' }}>
          {fixedUrl}
        </Typography>
      </Box>
    );
  };

  // Show loading state
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
        <Typography sx={{ ml: 2, color: '#FEFEFE' }}>Loading organization data...</Typography>
      </Box>
    );
  }

  // Show error state
  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', flexDirection: 'column' }}>
        <Typography variant="h6" sx={{ color: '#ff5252', mb: 2 }}>
          Error Loading Organization
        </Typography>
        <Typography sx={{ color: '#FEFEFE' }}>
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <div
      style={{
        height: "calc(100% - 6%)",
        overflow: "scroll",
        overflowX: "hidden",
        scrollbarWidth: "thin",
        msOverflowStyle: "none",
        scrollbarColor: "transparent transparent",
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        {/* Organization Header with Logo */}
        <Box sx={{ marginTop: "8px", textAlign: "center", px: 2 }}>
         {/*  {organizationData && (
            <Box>
              <OrganizationLogo 
                logoUrl={organizationData.organization_logo_url}
                organizationName={organizationData.organization_name}
              />
              <Typography variant="h5" sx={{ color: '#FEFEFE', marginBottom: 2 }}>
                {organizationData.organization_name}
              </Typography>
              <Typography variant="body2" sx={{ color: '#B9B9B9', marginBottom: 1 }}>
                {organizationData.organization_domain}
              </Typography>
              
              {/* Debug info - remove in production */}
             {/*  <Typography variant="caption" sx={{ color: '#666', display: 'block', mt: 1 }}>
                Logo URL: {organizationData.organization_logo_url || 'No logo URL'}
              </Typography>
            </Box>
          )}
          */}
          
          {/* Your existing SampleOrg component */}
          <SampleOrg organizationData={organizationData} />
        </Box>
      </Box>
    </div>
  );
};

export default OrganizationDashboard;